import { Component, OnInit, ViewChild } from '@angular/core';
import { Constants } from '../constants/constants';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { DatePipe } from '@angular/common';
import { ViewInvoiceListComponent } from './view-invoice-list/view-invoice-list.component';
import { EnvService } from '../service/env.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {

  invoices: Array<any> = new Array();
  accountCategory: string;
  accountType: string;
  viewInvoice: boolean = false;
  selectedInvoice: any;
  invoiceId: string;

  showPaymentProfile: boolean = false;

  @ViewChild('invoiceListComponent', { static: true }) invoiceListComponent:ViewInvoiceListComponent;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private route: ActivatedRoute, private utilService: UtilService, private toast: ToastService,
    private env: EnvService) { }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    this.route.queryParams.subscribe(params => {
      this.invoiceId = params["id"];
      console.log("invoice id::", this.invoiceId);
      this.getInvoices();
    });
    this.setShowPaymentProfile();
  }

  getInvoices() {
    this.invoices = [];
    this.utilService.showSpinner();
    this.apiService.getInvoices().then((data) => {
      this.utilService.hideSpinner();
      console.log("Invoices data::", data);
      this.invoices = data;
      this.showSelectedInvoice();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getInvoices();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  showSelectedInvoice() {
    let invoice = this.invoices.find(invoice => invoice.invoiceId === this.invoiceId);
    console.log("show selected invoice::", invoice);
    if(invoice) {
      this.invoiceListComponent.onInvoiceSelected(invoice);
      this.onInvoiceSelected(invoice);
    }
  }

  onInvoiceSelected(invoice) {
    this.selectedInvoice = invoice;
    this.viewInvoice = true;
  }

  onCloseInvoiceView() {
    this.selectedInvoice = null;
    this.viewInvoice = false;
    this.invoiceListComponent.onCloseInvoiceView();
    this.getInvoices()
  }

  setShowPaymentProfile() {
    this.showPaymentProfile = this.env.SHOW_PAYMENT;
  }

}
